import { useTranslation } from 'react-i18next';
import { isUndefined } from 'lodash';
import { Button } from 'components/Button';
import { Heading } from 'components/Typography';
import { InsuranceContext, withInsuranceMachineState } from 'domains/signup/insurance/data/insuranceEntryContext';
import { NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION } from 'domains/signup/insurance/data/insurance';

const UI: React.FC = () => {
  const medicaidProvider = InsuranceContext.useSelector(({ context }) => context.medicaidProvider);
  const { send } = InsuranceContext.useActorRef();

  const { t } = useTranslation();

  const isUnknownProvider =
    isUndefined(medicaidProvider) || medicaidProvider === NOT_ACCEPTED_INSURANCE_PROVIDER_OPTION.value;

  return (
    <>
      <Heading level="h2" className="mb-16">
        {!isUnknownProvider
          ? t(`signup.direct.steps.insuranceNotInNetwork.title`, { provider: medicaidProvider })
          : t(`signup.direct.steps.insuranceNotInNetwork.title.unknownProvider`)}
      </Heading>
      <Heading level="h7" className="mb-64 sm-d:mb-40">
        {t(`signup.direct.steps.insuranceNotInNetwork.subtitle`)}
      </Heading>

      <Button
        size="lg"
        onClick={() =>
          send({
            type: 'scheduleWithPrivatePay',
          })
        }
      >
        {t(`signup.direct.steps.insuranceNotInNetwork.scheduleButton`)}
      </Button>
    </>
  );
};

export const InsuranceNotInNetwork = withInsuranceMachineState(UI, 'insuranceNotInNetwork');
